export const account_type = '101';
export const game_id = "28014"